import { Component, InjectionToken, ReflectiveInjector } from '@angular/core';
import { ComponentPortal } from '@angular/cdk/portal';
import { AtpNotificationsSettings } from './atp-notifications.service';

export const NOTIFICATION_COMPONENT_INJECTOR_DATA = new InjectionToken<AtpNotificationData<any>>('notification_component_injector_data');

export class AtpNotificationData<TData> {
  data: TData;
  detach: () => void;
}

@Component({
  selector: 'atp-notifications',
  template: `<ng-template *ngFor="let portal of portals" [cdkPortalOutlet]="portal"></ng-template>`
})
export class AtpNotificationsComponent {

  constructor() { }

  portals: ComponentPortal<any>[] = [];

  addMessage(settings: AtpNotificationsSettings) {
    let newComponentPortal: ComponentPortal<any>;
    let data = new AtpNotificationData<any>();
    data.data = settings.data;
    data.detach = () => { newComponentPortal.detach(); this.portals = this.portals.filter(x => x.isAttached); };
    newComponentPortal = new ComponentPortal(settings.messageType, null, ReflectiveInjector.fromResolvedProviders(ReflectiveInjector.resolve([{ provide: NOTIFICATION_COMPONENT_INJECTOR_DATA, useValue: data }])));
    this.portals.push(newComponentPortal);
    setTimeout(() => {
      if (newComponentPortal.isAttached) {
        data.detach();
      }
    }, settings.time || 5000);
  }

}